import React, { useContext, useEffect } from "react";
import _ from "lodash";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import Gpsaddmodel from "./Models/Gpsaddmodel";
import UpdateModel from "./Models/UpdateModel";
import ComptableContext from "../../../context/ComptableContext";
import AccessoireModel from "./Models/AccessoireModel";

const Gps = () => {
  const { typeacc, getTypesacc } = useContext(ComptableContext);
  useEffect(() => {
    getTypesacc();
  }, []);

  return (
    <div>
      <AccessoireModel id="3" />
      <MDBContainer className="porfils pt-4" style={{ maxWidth: "1929" }}>
        <MDBAccordion initialActive={0}>
          {typeacc
            ? typeacc.map((appareil) => (
                <MDBAccordionItem
                  collapseId={appareil.id}
                  headerTitle={appareil.nameType}
                  key={appareil.id}
                >
                  <Gpsaddmodel
                    id={appareil.id}
                    data={appareil}
                    appareil_id="3"
                  />
                  <div
                    className="Table-tech"
                    style={{ width: "100%", overflowX: "auto" }}
                  >
                    <MDBTable align="middle">
                      <MDBTableHead>
                        <tr>
                          <th scope="col">Modele</th>
                          <th scope="col">Modifier</th>
                        </tr>
                      </MDBTableHead>

                      <MDBTableBody>
                        {appareil.modeles.map((modele) => (
                          <tr key={modele.id}>
                            <td>{modele.nameModele}</td>

                            <td>
                              <UpdateModel data={modele} appareil_id="3" />
                            </td>
                          </tr>
                        ))}
                      </MDBTableBody>
                    </MDBTable>
                  </div>
                </MDBAccordionItem>
              ))
            : ""}
        </MDBAccordion>
      </MDBContainer>
    </div>
  );
};

export default Gps;
